import {
  ActivatedRouteSnapshot,
  createUrlTreeFromSnapshot,
  MaybeAsync,
  RedirectCommand,
  ResolveFn,
} from "@angular/router";
import { inject } from "@angular/core";
import {
  AccountSelectionService,
  BaseStrategyService,
  DspStrategyService,
  SbStrategyService,
  SdStrategyService,
  SpStrategyService,
} from "@front/m19-services";
import { map, switchMap } from "rxjs";
import { CampaignType } from "@front/m19-api-client";

export type StrategyPageData = { strategyId: number; strategyGroupId?: number | undefined };
export type StrategyPageResolver = ResolveFn<StrategyPageData | RedirectCommand>;

export const spStrategyPageResolver: StrategyPageResolver = (route: ActivatedRouteSnapshot) => {
  const spStrategyService = inject(SpStrategyService);
  return strategyPageResolver(route, spStrategyService);
};

export const sbStrategyPageResolver: StrategyPageResolver = (route: ActivatedRouteSnapshot) => {
  const sbStrategyService = inject(SbStrategyService);
  return strategyPageResolver(route, sbStrategyService);
};

export const sdStrategyPageResolver: StrategyPageResolver = (route: ActivatedRouteSnapshot) => {
  const sdStrategyService = inject(SdStrategyService);
  return strategyPageResolver(route, sdStrategyService);
};

export const dspStrategyPageResolver: StrategyPageResolver = (route: ActivatedRouteSnapshot) => {
  const dspStrategiesService = inject(DspStrategyService);
  return strategyPageResolver(route, dspStrategiesService);
};

const strategyPageResolver = (
  route: ActivatedRouteSnapshot,
  strategiesService: BaseStrategyService<CampaignType>,
): MaybeAsync<StrategyPageData | RedirectCommand> => {
  const accountSelectionService = inject(AccountSelectionService);

  const params = route.paramMap;

  const id = Number(params.get("id"));

  return accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    switchMap((am) => strategiesService.getStrategies(am.accountId, am.marketplace)),
    map((strategies) => {
      const strategy = strategies.get(id);

      if (!strategy) {
        return new RedirectCommand(createUrlTreeFromSnapshot(route, [".."]));
      }

      return {
        strategyId: strategy.strategyId!,
      };
    }),
  );
};
